export enum UserFilterSourceEnum {
  manufacturerOutlet = 1,
  globalSearch = 2
}
